export function DashCard({ className = '', children, ...rest }) {
  return (
    <div className={`dash-card ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function KpiCard({ label, value, caption, icon: Icon, onClick, testId, loading }) {
  const interactive = typeof onClick === 'function';
  return (
    <DashCard
      className={`p-5 ${interactive ? 'dash-card-interactive' : ''}`}
      onClick={onClick}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onKeyDown={interactive ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } } : undefined}
      data-testid={testId}
    >
      <div className="flex items-start justify-between gap-2">
        <p className="dash-label">{label}</p>
        {Icon && (
          <span className="dash-icon-chip" aria-hidden="true">
            <Icon className="w-4 h-4" />
          </span>
        )}
      </div>
      {loading ? (
        <div className="dash-skeleton h-8 w-20 mt-3" aria-hidden="true" />
      ) : (
        <p
          className="dash-kpi-value mt-2"
          // A word-length value ("Not enough data") at headline size would overflow a KPI card.
          style={typeof value === 'string' && value.length > 8 ? { fontSize: '1.125rem', lineHeight: 1.35 } : undefined}
          data-testid={testId ? `${testId}-value` : undefined}
        >
          {value}
        </p>
      )}
      {caption && !loading && <p className="dash-caption mt-1.5">{caption}</p>}
    </DashCard>
  );
}

export function ChartCard({ title, subtitle, action, children, className = '', testId }) {
  return (
    <DashCard className={`p-5 ${className}`} data-testid={testId}>
      <div className="flex items-start justify-between gap-3 mb-4">
        <div className="min-w-0">
          <h3 className="font-heading text-base font-semibold" style={{ color: 'var(--dash-text)' }}>{title}</h3>
          {subtitle && <p className="dash-caption mt-0.5">{subtitle}</p>}
        </div>
        {action}
      </div>
      {children}
    </DashCard>
  );
}

export function EmptyState({ icon: Icon, title, body, testId }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-10 px-4" data-testid={testId}>
      {Icon && (
        <span className="dash-icon-chip mb-3" aria-hidden="true">
          <Icon className="w-4 h-4" />
        </span>
      )}
      <p className="text-sm font-medium" style={{ color: 'var(--dash-text)' }}>{title}</p>
      {body && <p className="dash-caption mt-1 max-w-sm">{body}</p>}
    </div>
  );
}
